import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";

type DateRangeProps = {
  startDate?: Date | null;
  endDate?: Date | null;
  className?: string;
  onStartDateChange?: Function;
  onEndDateChange?: Function;
  startLabel?: string;
  endLabel?: string;
  id?: string;
  minDate?: Date | null;
  maxDate?: Date | null;
  disabled?: boolean;
  disabledEnd?: boolean;
  disabledStart?: boolean;
  hidden?: boolean;
  hiddenEnd?: boolean;
  hiddenStart?: boolean;
};

const DateRange = ({
  startDate,
  endDate,
  className,
  onStartDateChange,
  onEndDateChange,
  startLabel,
  endLabel,
  minDate,
  maxDate,
  disabled = false,
  disabledEnd = false,
  disabledStart = false,
  hidden = false,
  hiddenEnd = false,
  hiddenStart = false,
}: DateRangeProps) => {
  return !hidden ? (
    <>
      <div
        className={className ? className : ""}
        style={{ visibility: hiddenStart ? "hidden" : "visible" }}
      >
        {startLabel && <Form.Label>{startLabel}</Form.Label>}
        <DatePicker
          disabled={disabled || disabledStart}
          className="form-control"
          selected={startDate}
          placeholderText="Start Date"
          onChange={(date: Date) => {
            onStartDateChange && onStartDateChange(date);
          }}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>
      <div className={className ? className : "mt-2"} 
        style={{ visibility: hiddenEnd ? "hidden" : "visible" }}>
        {endLabel && <Form.Label>{endLabel}</Form.Label>}
        <DatePicker
          disabled={disabled || disabledEnd}
          className="form-control"
          selected={endDate}
          placeholderText="End Date"
          onChange={(date: Date) => {
            onEndDateChange && onEndDateChange(date);
          }}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          maxDate={maxDate}
        />
      </div>
    </>
  ) : null;
};
export default DateRange;
